import {IDictionnaries} from '@app/components/projects/surveys/annotation/store/models/dictionnaries';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {Responses} from '@models/Surveys/response';
import {DoWorksService} from '@app/4dm1n/works-dashboard/do-works.service';
import {
  IAnnoQuestionDef
} from '@app/components/projects/surveys/annotation/_components/annotations-explorer/annotations-explorer.service';

export interface IAnnotationsData {
  survey: any;
  questions: IAnnoQuestionDef[];
  responses: Responses;
  dictionaries: IDictionnaries;
  currentExplorationState: {
    exploKeywordsSelected: any[];
  };
  currentManagerState: {
    groupTree: any[];
    keywordsTree: any[];
  };
  categoriesTree: {};
  taln: {};
  freezedResponses: any[];
  annotationIds: {};
  params: { wordFreqLaunched: boolean };
}

@Injectable({
  providedIn: 'root'
})
export class AnnotationDataService {

  public localData: IAnnotationsData = {
    survey: {},
    questions: [],
    responses: {
      responsesByQuestionId: {},
      questionsIdIndex: []
    },
    currentExplorationState: {
      exploKeywordsSelected: []
    },
    currentManagerState: {
      groupTree: [],
      keywordsTree: []
    },
    taln: {},
    categoriesTree: {},
    dictionaries: {
      words: {
        all: [],
        all_noExtra: [],
        noExtra: {},
        questionsId: []
      },
      groupIndex: {
        all: []
      }
    },
    freezedResponses: [],
    annotationIds: {},
    params: {
      wordFreqLaunched: false
    }
  };

  constructor(
    public doWorksService: DoWorksService,
  ) {}

  public setAnnotationsData(): number {
    return this.localData.responses.questionsIdIndex.length || 0;
  }

  public obsSetDAnnotationsData(): Observable<any> {
    return of(this.setAnnotationsData());
  }
}
